var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({class:[
    ( _obj = {}, _obj[_vm.css()] = true, _obj ),
    _vm.css('', _vm.type),
    _vm.css('', _vm.size),
    ( _obj$1 = {}, _obj$1[_vm.css('', 'loading')] = _vm.isLoading, _obj$1 ) ],attrs:{"data-test":"atom-button"},on:{"click":function($event){$event.preventDefault();return _vm.onClick()}}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),(_vm.isLoading)?_c('div',{class:_vm.css('circle'),attrs:{"data-test":"loading"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }